import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { BadgeModule } from 'primeng/badge';

import { LayoutComponent } from '../../components/layout/layout.component';
import { AcademyService } from '../../services/academy/academy.service';
import { LoadingService } from '../../services/loading/loading.service';

@Component({
  selector: 'app-home',
  imports: [
    LayoutComponent,
    CommonModule,
    BadgeModule
  ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent {
  public courses: any[] = [];
  public currentVideoUrl: SafeResourceUrl | null = null;

  constructor(
    private sanitizer: DomSanitizer,
    private AcademyService: AcademyService,
    private loading: LoadingService
  ) { }

  ngOnInit() {
    this.getCourses();
  }

  getCourses() {
    this.loading.show();

    this.AcademyService.getCourses().subscribe({
      next: (res) => {
        this.loading.hide();
        this.courses = res;

        console.log('CURSOS', this.courses);
      },
      error: (err) => {
        this.loading.hide();
        console.error(err);
      }
    });
  }

  getYouTubeThumbnail(videoId: string): string {
    return `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;
  }

  openVideoModal(videoId: string) {
    this.currentVideoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      `${videoId}?autoplay=1`
    );
  }

  closeVideoModal() {
    this.currentVideoUrl = null;
  }

  view(course: any) {
    let url = course.url == 'null' ? course.file : course.url;
    window.open(url)
  }
}
